import { useTheme } from '../useTheme'

const get = (color, hue) => `${color}.${hue}`

const solidStyle = ({ color }) => {
  return {
    bg: get(color, 500),
    color: 'white',
  }
}

const subtleStyle = ({ color }) => {
  return {
    bg: get(color, 100),
    color: get(color, 800),
  }
}

const outlineStyle = ({ theme: { colors }, color }) => {
  const boxShadowColor = colors[color] && colors[color][500]
  return {
    boxShadow: `inset 0 0 0px 1px ` + boxShadowColor,
    color: get(color, 500),
  }
}

const variantProps = props => {
  const { variant } = props
  switch (variant) {
    case 'solid':
      return solidStyle(props)
    case 'subtle':
      return subtleStyle(props)
    case 'outline':
      return outlineStyle(props)
    default:
      return {}
  }
}

const roundnessProps = props => {
  const { isRound } = props
  if (!isRound) return {}
  return {
    borderRadius: '50%',
    size: '1.25rem',
  }
}

export const useBadgeStyle = props => {
  const theme = useTheme()
  const _props = { ...props, theme }

  return {
    ...roundnessProps(_props),
    ...variantProps(_props),
  }
}

export default useBadgeStyle
